import React, { useEffect, useState } from "react";
import Header from "../../components/ui/Header";
import { Formik } from "formik";
import CButton from "../../components/ui/Button";
import TinyTextEditor from "../../components/ui/TinyTextEditor";
import {
  createProposals,
  getProposalDetails,
  updateProposal,
} from "../../graphs/getProposals";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import ViewImagesModal from "../../components/ui/modal/ViewImagesModal";
import UploadImage from "../../components/ui/modal/UploadImage";
import { notification } from "antd";
import { faImages, faUpload } from "@fortawesome/free-solid-svg-icons";

const EditProposal = ({}) => {
  const [viewImageModal, setViewImagesModal] = useState(false);
  const [uploadImageModal, setUploadImageModal] = useState(false);
  const [proposalData, setProposalData] = useState();
  const user_id = useSelector((state) => state?.auth?.loginUserData?.user_id);
  const first_name = useSelector(
    (state) => state?.auth?.loginUserData?.first_name
  );
  const last_name = useSelector(
    (state) => state?.auth?.loginUserData?.last_name
  );
  const AuthToken = useSelector((state) => state?.auth?.authToken);

  const { state } = useLocation();

  const getProposalDetail = async () => {
    try {
      await getProposalDetails(AuthToken, state?.id).then((res) => {
        setProposalData(res?.data);
        //   setProposalData(res?.data?.data)
      });
    } catch (err) {
      throw err;
    }
  };

  useEffect(() => {
    getProposalDetail();
  }, []);

  const handleSubmit = async (value) => {
    let formData = new FormData();
    formData.append("user_id", user_id);
    formData.append("first_name", first_name);
    formData.append("last_name", last_name);
    formData.append("title", value.projectTitle);
    formData.append("tableofcontents", value.talbleOfContent);
    formData.append("description", value.projectName);
    formData.append("greet", value.greeting);
    formData.append("company", value.ourCompany);
    formData.append("process", value.projectProcess);
    formData.append("deliverables", value.techStackDeliverable);
    formData.append("specification", value.projectSpecification);
    formData.append("timeline", value.projectTimeline);
    formData.append("price", value.esitmetAndSignedOff);
    formData.append("agreement", value.agreement);
    formData.append("is_featured", value?.is_featured);
    formData.append("is_active", value?.is_active);
    formData.append("image", value?.image);

    try {
      await updateProposal(AuthToken, formData, state?.id).then((res) => {
        notification["success"]({
          message: "Proposal Edited Successfully",
        });
      });
    } catch (err) {
      throw err;
    }
  };

  const validateData = (value) => {
    const error = {};
    if (!value.projectTitle) {
      error.projectTitle = "Please enter value";
    } else if (!/^[a-zA-Z]+$/.test(value.projectTitle)) {
      error.projectTitle = "Accept alphabetic letters only";
    }
    if (!value.projectName) {
      error.projectName = "Please enter value";
    }
    if (!value.talbleOfContent) {
      error.talbleOfContent = "Please enter value";
    }
    if (!value.ourCompany) {
      error.ourCompany = "Please enter value";
    }
    if (!value.greeting) {
      error.greeting = "Please enter value";
    }
    if (!value.projectProcess) {
      error.projectProcess = "Please enter value";
    }
    if (!value.projectSpecification) {
      error.projectSpecification = "Please enter value";
    }
    if (!value.techStackDeliverable) {
      error.techStackDeliverable = "Please enter value";
    }
    if (!value.projectTimeline) {
      error.projectTimeline = "Please enter value";
    }
    if (!value.esitmetAndSignedOff) {
      error.esitmetAndSignedOff = "Please enter value";
    }
    if (!value.agreement) {
      error.agreement = "Please enter value";
    }
    return error;
  };

  return (
    <>
      <section class="py-8">
        <div className="px-4">
          <div className="flex items-center justify-between p-4 mb-6 bg-white shadow rounded overflow-x-auto">
            <h2 className="text-lg font-medium">Edit Proposal</h2>
            <div className="flex items-center ">
              <div className="flex items-center justify-center"></div>
              <div className="flex items-center gap-2">
                <CButton
                  onClick={() => {
                    setUploadImageModal(true);
                  }}
                  icon={faUpload}
                  title={"Upload Image"}
                />
                <CButton
                  onClick={() => {
                    setViewImagesModal(true);
                  }}
                  icon={faImages}
                  title={"View Images"}
                />
              </div>
            </div>
          </div>
        </div>

        <div class="container px-4 mx-auto">
          <div class="flex flex-wrap -mx-4">
            <div class="w-full lg:w-full px-4 mb-8 lg:mb-0">
              <div class="px-6 pb-6 pt-4 bg-white shadow rounded">
                <Formik
                  enableReinitialize="true"
                  initialValues={{
                    projectTitle: proposalData?.title
                      ? proposalData?.title
                      : "",
                    projectName: proposalData?.description
                      ? proposalData.description
                      : "",
                    talbleOfContent: proposalData?.tableofcontents
                      ? proposalData.tableofcontents
                      : "",
                    ourCompany: proposalData?.company
                      ? proposalData?.company
                      : "",
                    greeting: proposalData?.greet ? proposalData?.greet : "",
                    projectProcess: proposalData?.process
                      ? proposalData?.process
                      : "",
                    projectSpecification: proposalData?.specification
                      ? proposalData?.specification
                      : "",
                    techStackDeliverable: proposalData?.deliverables
                      ? proposalData.deliverables
                      : "",
                    projectTimeline: proposalData?.timeline
                      ? proposalData?.timeline
                      : "",
                    esitmetAndSignedOff: proposalData?.price
                      ? proposalData?.price
                      : "",
                    agreement: proposalData?.agreement
                      ? proposalData.agreement
                      : "",
                    image: proposalData?.image ? proposalData.image : "",
                    is_featured: proposalData?.is_featured
                      ? proposalData.is_featured
                      : "",
                    is_active: proposalData?.is_active
                      ? proposalData.is_active
                      : "",
                  }}
                  onSubmit={handleSubmit}
                  validate={validateData}
                >
                  {({
                    values,
                    handleBlur,
                    handleChange,
                    handleReset,
                    handleSubmit,
                    errors,
                    touched,
                    setFieldValue,
                    resetForm,
                  }) => (
                    <form onSubmit={handleSubmit} className="mb-4">
                      <div className="grid grid-cols-12 gap-4 items-center">
                        <div className="col-span-12">
                          <div className="w-full">
                            <div class="mb-2">
                              <label
                                class="block text-sm font-medium mb-2"
                                for=""
                              >
                                Project Title *
                              </label>
                              <input
                                class="block w-full px-4 py-3 text-sm placeholder-gray-500 bg-white border rounded"
                                type="text"
                                value={values?.projectTitle}
                                name="projectTitle"
                                id="projectTitle"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                placeholder="Title"
                              />
                              {errors.projectTitle && touched.projectTitle ? (
                                <p className="text-rose-500 text-sm">
                                  {errors.projectTitle}
                                </p>
                              ) : null}
                            </div>
                          </div>
                        </div>

                        <div className="col-span-12">
                          <div class="mb-2">
                            <label
                              class="block text-sm font-medium mb-2"
                              for=""
                            >
                              Project Name *
                            </label>
                            <TinyTextEditor
                              // initialValue={"<h1>Project Name</h1>\r\n<h5>Prepared by -</h5>\r\n<h4>Prometteur Solutions Pvt. Ltd.</h4>"}
                              className="block w-full px-4 py-3 mb-2 text-sm placeholder-gray-500 bg-white border rounded"
                              id={"projectName"}
                              onEditorChange={(content) =>
                                setFieldValue("projectName", content)
                              }
                              onBlur={handleBlur}
                              name={"projectName"}
                              value={values?.projectName}
                            />
                            {errors.projectName && touched.projectName ? (
                              <p className="text-rose-500 text-sm">
                                {errors.projectName}
                              </p>
                            ) : null}
                          </div>
                        </div>

                        <div className="col-span-12">
                          <div class="mb-2">
                            <label class="block text-sm font-medium mb-2">
                              Table of Content *
                            </label>
                            <TinyTextEditor
                              // initialValue={"<h1>Table Of Contents</h1>\r\n<ul>\r\n<li>1. Introduction</li>\r\n<li>2. Our Mission &amp; Vision</li>\r\n<li>3. Project Process</li>\r\n<li>4. Project Specifications</li>\r\n<li>5. Tech Stack &amp; Deliverable</li>\r\n<li>6. Timeline</li>\r\n<li>7. Estimate &amp; Sign Off</li>\r\n<li>8. Agreement</li>\r\n</ul>"}
                              className="block w-full px-4 py-3 mb-2 text-sm placeholder-gray-500 bg-white border rounded"
                              id={"talbleOfContent"}
                              onEditorChange={(content) =>
                                setFieldValue("talbleOfContent", content)
                              }
                              name={"talbleOfContent"}
                              onBlur={handleBlur}
                              value={values?.talbleOfContent}
                            />
                            {errors.talbleOfContent &&
                            touched.talbleOfContent ? (
                              <p className="text-rose-500 text-sm">
                                {errors.talbleOfContent}
                              </p>
                            ) : null}
                          </div>
                        </div>

                        <div className="col-span-12">
                          <div class="mb-2">
                            <label
                              class="block text-sm font-medium mb-2"
                              for=""
                            >
                              Our Company *
                            </label>
                            <TinyTextEditor
                              // initialValue={"<h1 style=\"text-align: center;\">Introduction</h1>\r\n<div class=\"compdiv1\">\r\n<div class=\"comp1\">\r\n<p>We at Prometteur Solutions Pvt. Ltd. are a team of IT experts, who came with a promise of delivering technology-empowered business solutions. We provide world-class software and web development services that focus on playing a supportive role to your business and its holistic growth. Our highly-skilled associates and global delivery capabilities ensure the accessibility and scale to align client's technology solutions with their business needs. Our offerings span the entire IT lifecycle: from Consulting through Packaged, Custom, and Cloud Applications as well as a variety of Infrastructure Services.</p>\r\n</div>\r\n<div class=\"comp2\"><img class=\"w-100\" src=\"assets/images/pdfimgs/who-we-are.jpg\" /></div>\r\n</div>\r\n<div class=\"comp5\">\r\n<h3 class=\"mt-4\">Attract Engage &amp; Convert</h3>\r\n<p>Prometteur, the mobile and web app development company has a human-centered design approach towards the client's goals that puts the user first and delivers a great digital experience. When you work with a proficient, experienced team, you will have fewer things to care about and more things to consider. We are highly skilled in creating, developing, and launching industry-leading digital solutions, including website development, web development, mobile app development, iOS, Android, Hybrid and Native Mobile Frameworks, IoT (Internet of Things), and SEO.</p>\r\n<p>We are ISO 90001: 2008 certified company and proud members of NASSCOM (The National Association of Software and Service Companies) a trade association of Indian Information Technology.</p>\r\n</div>"}
                              className="block w-full px-4 py-3 mb-2 text-sm placeholder-gray-500 bg-white border rounded"
                              id={"ourCompany"}
                              onEditorChange={(content) =>
                                setFieldValue("ourCompany", content)
                              }
                              name={"ourCompany"}
                              onBlur={handleBlur}
                              value={values?.ourCompany}
                            />
                            {errors.ourCompany && touched.ourCompany ? (
                              <p className="text-rose-500 text-sm">
                                {errors.ourCompany}
                              </p>
                            ) : null}
                          </div>
                        </div>

                        <div className="col-span-12">
                          <div class="mb-2">
                            <label
                              class="block text-sm font-medium mb-2"
                              for=""
                            >
                              Greeting *
                            </label>
                            <TinyTextEditor
                              // initialValue={"<h1 style=\"text-align: center;\">Our Mission &amp; Vision</h1>\r\n<p><img class=\"w-100\" src=\"assets/images/pdfimgs/com_bann.png\" /></p>\r\n<h3 class=\"mt-4\">Mission</h3>\r\n<p>To create a perennial Client base while nurturing employee spirit to achieve sustainable collective growth.</p>\r\n<h3 class=\"mt-4\">Vision</h3>\r\n<p>Our vision is to provide turnkey solutions to clients by means of our extensive experience while being innovative &amp; flexible. By working in close liaison with our clients we want to be known as our domain leader &amp; pioneer of the latest technological solutions across all industry verticals.</p>"}
                              className="block w-full px-4 py-3 mb-2 text-sm placeholder-gray-500 bg-white border rounded"
                              id={"greeting"}
                              onEditorChange={(content) =>
                                setFieldValue("greeting", content)
                              }
                              name={"greeting"}
                              onBlur={handleBlur}
                              value={values?.greeting}
                            />
                            {errors.greeting && touched.greeting ? (
                              <p className="text-rose-500 text-sm">
                                {errors.greeting}
                              </p>
                            ) : null}
                          </div>
                        </div>

                        <div className="col-span-12">
                          <div class="mb-2">
                            <label class="block text-sm font-medium mb-2">
                              Project Process *
                            </label>
                            <TinyTextEditor
                              // initialValue={"<h1>Project Process</h1>\r\n<p class=\"proc_img_out\"><img class=\"proc_img\" src=\"assets/images/pdfimgs/development-methodology.png\" /></p>\r\n<h3 class=\"mt-4\">How It Works!</h3>\r\n<p class=\"proc_head\"><strong>Initiation</strong></p>\r\n<p>At this stage, we gather the entire requirement for easy flow to proceed for the development of the IOS &amp; Android App and Web Admin and prepare a document for Client to understand our concept and also prepare information architecture. At this stage, we are in touch with clients continuously so that we can gather as much information.</p>\r\n<p class=\"proc_head\"><strong>Planning and Designing</strong></p>\r\n<p>We start with the planning of developing IOS &amp; Android App and Web Admin with estimated time and budget in order to avoid inconvenience.<br />Once Client approves it, we move ahead with storyboard creation and actual integration.</p>\r\n<p class=\"proc_head\"><strong>Development</strong></p>\r\n<p>The design is converted into the code at this stage by our IOS &amp; Android App and Web Admin developers. As part of this phase, we need to test these components thoroughly to confirm that they work as they should.</p>\r\n<p class=\"proc_head\"><strong>Testing</strong></p>\r\n<p>The phase-wise testing of each module is performed by our QA in order to make the system bug-free.</p>\r\n<p class=\"proc_head\"><strong>Maintenance and Support</strong></p>\r\n<p>Prometteur Solutions Proposes 45 days of Free Maintenance where we will fix any user-reported bugs in the application at no cost. Post the maintenance period, both Prometteur and the client team can mutually agree on the time, price, and terms of Support.</p>"}
                              className="block w-full px-4 py-3 mb-2 text-sm placeholder-gray-500 bg-white border rounded"
                              id={"projectProcess"}
                              onBlur={handleBlur}
                              onEditorChange={(content) =>
                                setFieldValue("projectProcess", content)
                              }
                              name={"projectProcess"}
                              value={values?.projectProcess}
                            />
                            {errors.projectProcess && touched.projectProcess ? (
                              <p className="text-rose-500 text-sm">
                                {errors.projectProcess}
                              </p>
                            ) : null}
                          </div>
                        </div>

                        <div className="col-span-12">
                          <div class="mb-2">
                            <label class="block text-sm font-medium mb-2">
                              Project Specification *
                            </label>
                            <TinyTextEditor
                              // initialValue={"<h1>Project Specifications</h1>\r\n<h3>Lorem Ipsum</h3>\r\n<p>Lorem Ipsum&nbsp;is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text</p>\r\n<div class=\"spec_ele_deta\">\r\n<p class=\"spac_user\"><strong>User (Client) : </strong>User</p>\r\n<p class=\"spec_ele\" style=\"display: table-row; width: 100%; float: left;\"><strong>Design element &amp; Functionality : </strong>Home page/landing page</p>\r\n<ul class=\"spec_inn3\" style=\"display: flex; align-items: top; padding: 0; width: 100%;\">\r\n<li style=\"list-style: none; white-space: nowrap;\"><strong>Details :</strong></li>\r\n<li style=\"list-style: none;\">\r\n<ul class=\"spec_inn_ul\" style=\"padding-left: 10px; width: 100%;\">\r\n<li class=\"w-100\" style=\"width: 100%; float: left; margin-bottom: 8px; list-style: none;\">1. Lorem Ipsum&nbsp;is simply dummy text of the printing and typesetting industry.</li>\r\n<li class=\"w-100\" style=\"width: 100%; float: left; margin-bottom: 8px; list-style: none;\">2. Lorem Ipsum&nbsp;is simply dummy text of the printing and typesetting industry.</li>\r\n<li class=\"w-100\" style=\"width: 100%; float: left; margin-bottom: 8px; list-style: none;\">3. Lorem Ipsum&nbsp;is simply dummy text of the printing and typesetting industry.</li>\r\n</ul>\r\n</li>\r\n</ul>\r\n<p class=\"spec_ele\" style=\"display: table-row; width: 100%; float: left;\"><strong>Design element &amp; Functionality : </strong>Career</p>\r\n<ul class=\"spec_inn3\" style=\"display: flex; align-items: top; padding: 0; width: 100%;\">\r\n<li style=\"list-style: none; white-space: nowrap;\"><strong>Details :</strong></li>\r\n<li style=\"list-style: none;\">\r\n<ul class=\"spec_inn_ul\" style=\"padding-left: 10px; width: 100%;\">\r\n<li class=\"w-100\" style=\"width: 100%; float: left; margin-bottom: 8px; list-style: none;\">1. Lorem Ipsum&nbsp;is simply dummy text of the printing and typesetting industry.</li>\r\n<li class=\"w-100\" style=\"width: 100%; float: left; margin-bottom: 8px; list-style: none;\">2. Lorem Ipsum&nbsp;is simply dummy text of the printing and typesetting industry.</li>\r\n<li class=\"w-100\" style=\"width: 100%; float: left; margin-bottom: 8px; list-style: none;\">3. Lorem Ipsum&nbsp;is simply dummy text of the printing and typesetting industry.</li>\r\n</ul>\r\n</li>\r\n</ul>\r\n<br class=\"br_none\" />\r\n<p class=\"spac_user\"><strong>User (Client) : </strong>Admin</p>\r\n<p class=\"spec_ele\" style=\"display: table-row; width: 100%; float: left;\"><strong>Design element &amp; Functionality : </strong>Login</p>\r\n<ul class=\"spec_inn3\" style=\"display: flex; align-items: top; padding: 0; width: 100%;\">\r\n<li style=\"list-style: none; white-space: nowrap;\"><strong>Details :</strong></li>\r\n<li style=\"list-style: none;\">\r\n<ul class=\"spec_inn_ul\" style=\"padding-left: 10px; width: 100%;\">\r\n<li class=\"w-100\" style=\"width: 100%; float: left; margin-bottom: 8px; list-style: none;\">1. Lorem Ipsum&nbsp;is simply dummy text of the printing and typesetting industry.</li>\r\n<li class=\"w-100\" style=\"width: 100%; float: left; margin-bottom: 8px; list-style: none;\">2. Lorem Ipsum&nbsp;is simply dummy text of the printing and typesetting industry.</li>\r\n<li class=\"w-100\" style=\"width: 100%; float: left; margin-bottom: 8px; list-style: none;\">3. Lorem Ipsum&nbsp;is simply dummy text of the printing and typesetting industry.</li>\r\n</ul>\r\n</li>\r\n</ul>\r\n<p class=\"spec_ele\" style=\"display: table-row; width: 100%; float: left;\"><strong>Design element &amp; Functionality : </strong>Sign up</p>\r\n<ul class=\"spec_inn3\" style=\"display: flex; align-items: top; padding: 0; width: 100%;\">\r\n<li style=\"list-style: none; white-space: nowrap;\"><strong>Details :</strong></li>\r\n<li style=\"list-style: none;\">\r\n<ul class=\"spec_inn_ul\" style=\"padding-left: 10px; width: 100%;\">\r\n<li class=\"w-100\" style=\"width: 100%; float: left; margin-bottom: 8px; list-style: none;\">1. Lorem Ipsum&nbsp;is simply dummy text of the printing and typesetting industry.</li>\r\n<li class=\"w-100\" style=\"width: 100%; float: left; margin-bottom: 8px; list-style: none;\">2. Lorem Ipsum&nbsp;is simply dummy text of the printing and typesetting industry.</li>\r\n<li class=\"w-100\" style=\"width: 100%; float: left; margin-bottom: 8px; list-style: none;\">3. Lorem Ipsum&nbsp;is simply dummy text of the printing and typesetting industry.</li>\r\n</ul>\r\n</li>\r\n</ul>\r\n</div>\r\n<p>&nbsp;</p>"}
                              className="block w-full px-4 py-3 mb-2 text-sm placeholder-gray-500 bg-white border rounded"
                              id={"projectSpecification"}
                              onEditorChange={(content) =>
                                setFieldValue("projectSpecification", content)
                              }
                              onBlur={handleBlur}
                              name={"projectSpecification"}
                              value={values?.projectSpecification}
                            />
                            {errors.projectSpecification &&
                            touched.projectSpecification ? (
                              <p className="text-rose-500 text-sm">
                                {errors.projectSpecification}
                              </p>
                            ) : null}
                          </div>
                        </div>

                        <div className="col-span-12">
                          <div class="mb-2">
                            <label class="block text-sm font-medium mb-2">
                              Tech Stack & Deliverable *
                            </label>
                            <TinyTextEditor
                              // initialValue={"<h1>Tech Stack &amp; Deliverable</h1>\r\n<ul class=\"deli_ul\">\r\n<li><strong>Game Engine:&nbsp;</strong>Unity</li>\r\n<li><strong>Backend:&nbsp;</strong>PHP</li>\r\n<li><strong>RealTime Actions:&nbsp;</strong>Socket.io / Photon PUN 2</li>\r\n<li><strong>Server:&nbsp;</strong>AWS</li>\r\n<li><strong>Database:&nbsp;</strong>MySQL</li>\r\n</ul>\r\n<table style=\"width: 100%;\" border=\"1\">\r\n<tbody>\r\n<tr class=\"deli_thead\">\r\n<td class=\"deli_thead_col1\"><strong>No</strong></td>\r\n<td><strong>User Role</strong></td>\r\n<td><strong>Platform</strong></td>\r\n</tr>\r\n<tr>\r\n<td class=\"deli_td1\">1</td>\r\n<td>Super Admin</td>\r\n<td>Web Panel</td>\r\n</tr>\r\n<tr>\r\n<td class=\"deli_td1\">2</td>\r\n<td>Admin</td>\r\n<td>Web Panel</td>\r\n</tr>\r\n<tr>\r\n<td class=\"deli_td1\">3</td>\r\n<td>Sub Admin</td>\r\n<td>Web Panel</td>\r\n</tr>\r\n<tr>\r\n<td class=\"deli_td1\">4</td>\r\n<td>User</td>\r\n<td>iOS &amp; Android App</td>\r\n</tr>\r\n</tbody>\r\n</table>\r\n<h3 class=\"mt-4\">Additional Notes</h3>\r\n<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>"}
                              className="block w-full px-4 py-3 mb-2 text-sm placeholder-gray-500 bg-white border rounded"
                              id={"techStackDeliverable"}
                              onEditorChange={(content) =>
                                setFieldValue("techStackDeliverable", content)
                              }
                              onBlur={handleBlur}
                              name={"techStackDeliverable"}
                              value={values?.techStackDeliverable}
                            />
                            {errors.techStackDeliverable &&
                            touched.techStackDeliverable ? (
                              <p className="text-rose-500 text-sm">
                                {errors.techStackDeliverable}
                              </p>
                            ) : null}
                          </div>
                        </div>

                        <div className="col-span-12">
                          <div class="mb-2">
                            <label class="block text-sm font-medium mb-2">
                              Project Timeline *
                            </label>
                            <TinyTextEditor
                              // initialValue={"<h1>Timeline</h1>\r\n<table style=\"width: 100%;\">\r\n<tbody>\r\n<tr>\r\n<td>\r\n<h4>Week1</h4>\r\n<p>Lorem Ipsum is simply dummy text.</p>\r\n</td>\r\n</tr>\r\n<tr>\r\n<td>\r\n<h4>Week</h4>\r\n<p>Lorem Ipsum is simply dummy text.</p>\r\n</td>\r\n</tr>\r\n</tbody>\r\n</table>"}
                              className="block w-full px-4 py-3 mb-2 text-sm placeholder-gray-500 bg-white border rounded"
                              id={"projectTimeline"}
                              onEditorChange={(content) =>
                                setFieldValue("projectTimeline", content)
                              }
                              onBlur={handleBlur}
                              name={"projectTimeline"}
                              value={values?.projectTimeline}
                            />
                            {errors.projectTimeline &&
                            touched.projectTimeline ? (
                              <p className="text-rose-500 text-sm">
                                {errors.projectTimeline}
                              </p>
                            ) : null}
                          </div>
                        </div>

                        <div className="col-span-12">
                          <div class="mb-2">
                            <label class="block text-sm font-medium mb-2">
                              Estimate and sign Off *
                            </label>
                            <TinyTextEditor
                              // initialValue={"<h1>Estimate &amp; Sign Off</h1>\r\n<table style=\"width: 100%;\">\r\n<tbody>\r\n<tr>\r\n<td><strong>Milestone</strong></td>\r\n<td class=\"text-center\"><strong>Timeline</strong></td>\r\n<td class=\"text-center\"><strong>Payment</strong></td>\r\n</tr>\r\n<tr>\r\n<td>Prototype design of the App, Website and Backend</td>\r\n<td class=\"text-center\">Week 1-2</td>\r\n<td class=\"text-center\">&euro;100</td>\r\n</tr>\r\n<tr>\r\n<td>Prototype design of the App, Website and Backend</td>\r\n<td class=\"text-center\">Week 1-2</td>\r\n<td class=\"text-center\">&euro;100</td>\r\n</tr>\r\n<tr>\r\n<td>Prototype design of the App, Website and Backend</td>\r\n<td class=\"text-center\">Week 1-2</td>\r\n<td class=\"text-center\">&euro;100</td>\r\n</tr>\r\n<tr>\r\n<td>Prototype design of the App, Website and Backend</td>\r\n<td class=\"text-center\">Week 1-2</td>\r\n<td class=\"text-center\">&euro;100</td>\r\n</tr>\r\n<tr>\r\n<td>Prototype design of the App, Website and Backend</td>\r\n<td class=\"text-center\">Week 1-2</td>\r\n<td class=\"text-center\">&euro;100</td>\r\n</tr>\r\n<tr>\r\n<td>Prototype design of the App, Website and Backend</td>\r\n<td class=\"text-center\">Week 1-2</td>\r\n<td class=\"text-center\">&euro;100</td>\r\n</tr>\r\n<tr>\r\n<td><strong>Total :</strong></td>\r\n<td class=\"text-center\"><strong>Week 10</strong></td>\r\n<td class=\"text-center\"><strong>&euro;600</strong></td>\r\n</tr>\r\n</tbody>\r\n</table>\r\n<p>&nbsp;</p>"}
                              className="block w-full px-4 py-3 mb-2 text-sm placeholder-gray-500 bg-white border rounded"
                              id={"esitmetAndSignedOff"}
                              onEditorChange={(content) =>
                                setFieldValue("esitmetAndSignedOff", content)
                              }
                              onBlur={handleBlur}
                              name={"esitmetAndSignedOff"}
                              value={values?.esitmetAndSignedOff}
                            />
                            {errors.esitmetAndSignedOff &&
                            touched.esitmetAndSignedOff ? (
                              <p className="text-rose-500 text-sm">
                                {errors.esitmetAndSignedOff}
                              </p>
                            ) : null}
                          </div>
                        </div>

                        <div className="col-span-12">
                          <div class="mb-2">
                            <label class="block text-sm font-medium mb-2">
                              Agreement *
                            </label>
                            <TinyTextEditor
                              // initialValue={"<h1>Agreement</h1>\r\n<h5><strong><em>This agreement is made between :</em></strong></h5>\r\n<ul>\r\n<li><strong>Name : </strong>Prometteur Solutions Pvt. Ltd.</li>\r\n<li><strong>Address :&nbsp;</strong>Lorem Ipsum is simply dummy text, Lorem Ipsum-122452</li>\r\n<li><strong>Phone :&nbsp;</strong>01234546789</li>\r\n<li><strong>Email : </strong>lorem@prometteursolutions.com</li>\r\n</ul>\r\n<h5 class=\"mb-3\"><strong><em>&amp;</em></strong></h5>\r\n<ul>\r\n<li><strong>Name :</strong> Lorem Ipsum Pvt. Ltd.</li>\r\n<li><strong>Address :&nbsp;</strong>Lorem Ipsum is simply dummy text, Lorem Ipsum-122452</li>\r\n<li><strong>Phone :&nbsp;</strong>01234546789</li>\r\n<li><strong>Email : </strong>lorem@prometteursolutions.com</li>\r\n</ul>\r\n<p>&nbsp;</p>\r\n<p>&nbsp;</p>\r\n<table style=\"width: 100%;\">\r\n<tbody>\r\n<tr>\r\n<td style=\"width: 50%;\"><hr />\r\n<p class=\"agreename\"><strong>Swapnil T. (COO)</strong></p>\r\n<p>Prometteur Solutions Pvt. Ltd.</p>\r\n<p><strong>Date :&nbsp;</strong>06 July 2020</p>\r\n</td>\r\n<td style=\"width: 50%;\"><hr />\r\n<p class=\"agreename\"><strong>Ami N. (COO)</strong></p>\r\n<p>Lorem Ipsum Pvt. Ltd.</p>\r\n<p><strong>Date :&nbsp;</strong>06 July 2020</p>\r\n</td>\r\n</tr>\r\n</tbody>\r\n</table>"}
                              className="block w-full px-4 py-3 mb-2 text-sm placeholder-gray-500 bg-white border rounded"
                              id={"agreement"}
                              onEditorChange={(content) =>
                                setFieldValue("agreement", content)
                              }
                              onBlur={handleBlur}
                              name={"agreement"}
                              value={values?.agreement}
                            />
                            {errors.agreement && touched.agreement ? (
                              <p className="text-rose-500 text-sm">
                                {errors.agreement}
                              </p>
                            ) : null}
                          </div>
                        </div>

                        <CButton type="submit" title={"Submit"} />
                      </div>
                    </form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
        <UploadImage
          uploadImageModal={uploadImageModal}
          setUploadImageModal={setUploadImageModal}
        />
        <ViewImagesModal
          viewImageModal={viewImageModal}
          setViewImagesModal={setViewImagesModal}
        />
      </section>
    </>
  );
};

export default EditProposal;
